import { __ } from "@wordpress/i18n";
import LoginActionLoginSettings from "../LoginActionLoginSettings";
import RestrictionsSettings from "../RestrictionsSettings";
import Security2faAuthentication from "../Security2faAuthentication";
import SecurityErrorNotification from "../SecurityErrorNotification";
import SecurityLoginSecurity from "../SecurityLoginSecurity";
import SecurityPasswordPolicies from "../SecurityPasswordPolicies";


const setupSteps = [
    {
        id: "login-settings",
        title: __("Login Settings Setup", "ultimate-security"),
        description: __("Setup Wizard will help you setup Ultimate Security in a few steps", "ultimate-security"), 
        component: <LoginActionLoginSettings />,
        componentRef: LoginActionLoginSettings,
    },
    {
        id: "login-security",
        title: __("Login Security Setup", "ultimate-security"),
        description: __("Setup Wizard will help you setup Ultimate Security in a few steps", "ultimate-security"), 
        component: <SecurityLoginSecurity />,
        componentRef: SecurityLoginSecurity,
    },
    {
        id: "password-policies",
        title: __("Password Policies Setup", "ultimate-security"),
        description: __("Setup Wizard will help you setup Ultimate Security in a few steps", "ultimate-security"), 
        component: <SecurityPasswordPolicies />,
        componentRef: SecurityPasswordPolicies,
    },
    {
        id: "2fa-auth",
        title: __("2FA Authentication Setup", "ultimate-security"),
        description: __("Setup Wizard will help you setup Ultimate Security in a few steps", "ultimate-security"), 
        component: <Security2faAuthentication />,
        componentRef: Security2faAuthentication,
    },
    {
        id: "restrictions-settings",
        title: __("Restrictions Settings Setup", "ultimate-security"),
        description: __("Setup Wizard will help you setup Ultimate Security in a few steps", "ultimate-security"), 
        component: <RestrictionsSettings />,
        componentRef: RestrictionsSettings,
    },
    {
        id: "error-notification",
        title: __("Error Notification Setup", "ultimate-security"),
        description: __("Setup Wizard will help you setup Ultimate Security in a few steps", "ultimate-security"), 
        component: <SecurityErrorNotification />,
        componentRef: SecurityErrorNotification,
    },
];

export default setupSteps;